import endpoints from '../endpoints'
import axios from 'axios'

const state = {
  content: {
    user: {},
    userLocations: [],
    feedback: ''
  }
}

const getters = {
  user: state => state.content.user,
  userLocations: state => state.content.userLocations,
  uniqueUserLocations: (state) => {
    let locations = {}

    Object.values(state.content.userLocations).forEach((item) => {
      locations[item.item_geoid] = item
    })

    return locations
  },
  isLoggedIn: state => (typeof state.content.user.id !== 'undefined' && state.content.user.id > 0),
  userFeedback: state => state.content.feedback
}

const actions = {
  getUserData ({ commit, rootState }) {
    axios.post(endpoints.userData)
      .then(({data}) => {
        commit('setUserData', data.user)
        commit('setUserLocations', data.locations)
        commit('updateCustomer', {
          item_vorname: data.user.item_firstname,
          item_name: data.user.item_lastname,
          item_handy: data.user.item_phone,
          item_email: data.user.item_email
        }, { root: true })
      })
  },

  userRegistration ({ commit, dispatch }, payload) {
    axios.post(endpoints.userRegistration, payload)
      .then(({data}) => {
        if (data.success) {
          dispatch('login', {
            email: payload.item_email,
            password: payload.item_password
          })
        } else {
          commit('setFeedback', data.registrationResponse)
          alert('Das hat leider nicht funktioniert 😭')
        }
      })
      .catch(e => {
        console.log(['failed userRegistration', e])
      })
  },

  resendActivationCode ({ state }) {
    axios.post(endpoints.userResendActivationCode, {
      email: state.content.user.item_email
    })
      .then(({data}) => {
        if (data.success) {
          alert('Das hat funktioniert - wir haben dir einen neuen Aktivierungscode per SMS gesendet 👍')
        } else {
          alert('Das hat leider nicht funktioniert 😭')
        }
      })
      .catch(e => {
        console.log(['failed resendActivationCode', e])
      })
  },

  userActivation ({ dispatch }, payload) {
    axios.post(endpoints.userActivation, {
      code: payload
    })
      .then(({data}) => {
        dispatch('getUserData')
        if (data.success) {
          // redirect?
        } else {
          alert('Aktivierung fehlgeschlagen 😭')
        }
      })
      .catch(e => {
        console.log(['failed userActivation', e])
      })
  },

  login ({ dispatch }, payload) {
    axios.post(endpoints.userLogin, {
      login: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
        } else {
          alert('Login fehlgeschlagen 😭')
        }
      })
      .catch(e => {
        console.log(['failed login', e])
      })
  },

  logout ({ commit, dispatch }) {
    axios.post(endpoints.userLogout)
      .then(() => {
        commit('unsetUserData')
      })

    dispatch('cleanCustomerData', { root: true })
  },

  addOrUpdateLocation ({ dispatch }, payload) {
    axios.post(endpoints.addOrUpdateUserLocation, {
      address: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
        } else {
          alert('Ändern der Adresse fehlgeschlagen 😭')
        }
      })
  },

  deleteLocation ({ dispatch }, payload) {
    axios.post(endpoints.deleteUserLocation, {
      id: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
        } else {
          alert('Löschen fehlgeschlagen 😭')
        }
      })
  },

  deleteUser ({ dispatch }, payload) {
    axios.post(endpoints.deleteUser, {
      login: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('logout')
        } else {
          alert('Löschen fehlgeschlagen 😭')
        }
      })
  },

  updateUserPasswd ({ dispatch }, payload) {
    axios.post(endpoints.userChangePasswd, {
      login: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
        } else {
          alert('Passwort ändern fehlgeschlagen 😭')
        }
      })
  },

  updateUserAccount ({ dispatch }, payload) {
    axios.post(endpoints.userUpdateAccount, {
      account: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
        } else {
          alert('Ändern der Daten fehlgeschlagen 😭')
        }
      })
  },

  userForgotPasswd ({ dispatch }, payload) {
    axios.post(endpoints.userForgotPasswd, {
      account: payload
    })
  },

  userResetPasswd ({ dispatch }, payload) {
    axios.post(endpoints.userResetPasswd, {
      account: payload
    })
      .then(({data}) => {
        if (data.success) {
          dispatch('getUserData')
          window.location.href = '/einstellungen'
        } else {
          if (data.error) {
            alert(data.error)
          } else {
            alert('Ändern der Daten fehlgeschlagen 😭')
          }
        }
      })
  }
}

const mutations = {
  setUserData (state, userData) {
    state.content.user = userData
  },

  setUserLocations (state, userLocations) {
    state.content.userLocations = userLocations
  },

  unsetUserData (state) {
    state.content.user = {}
  },

  setFeedback (state, feedback) {
    state.content.feedback = feedback
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js